import React from 'react';
import Iconify from '../../componentes/Iconify';
import { workWithLocalStorage } from '../../auxiliares/funciones';

import Citas from '../../paginas/agenda/citas';
import Clientes from '../../paginas/clientes';
import ClientesAlta from '../../paginas/clientes/alta';
import Trabajadores from '../../paginas/trabajadores';
import TrabajadoresAlta from '../../paginas/trabajadores/alta';
import Servicios from '../../paginas/servicios';
import ServiciosAlta from '../../paginas/servicios/alta';
import Rooms from '../../paginas/rooms';
import RoomsAlta from '../../paginas/rooms/alta';
import LectorCupones from '../../paginas/cupones/lector';

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

// Definición maestra de menús por perfil:
// idPerfil = 1 -> Mostrador (Todas las opciones)
// idPerfil = 2 -> Dispositivo (Solo Lector Cupones y Clientes)
const menuConfig = [
  {
    id: 1,
    title: 'Agenda',
    path: '#',
    perfil: [1],
    icon: getIcon('eva:calendar-fill'),
    component: Citas,
    params: {}
  },
  {
    id: 6,
    title: 'Lector Cupones',
    path: '#',
    perfil: [1, 2],
    icon: getIcon('eva:qr-code-fill'),
    component: LectorCupones,
    params: {}
  },
  {
    id: 2,
    title: 'Clientes',
    path: '#',
    perfil: [1, 2],
    icon: getIcon('eva:people-fill'),
    children: [
      {
        id: 21,
        title: 'Alta Cliente',
        path: '#',
        perfil: [1, 2],
        icon: getIcon('eva:person-add-fill'),
        component: ClientesAlta,
        params: {}
      },
      {
        id: 22,
        title: 'List. Clientes',
        path: '#',
        perfil: [1, 2],
        icon: getIcon('eva:people-fill'),
        component: Clientes,
        params: {}
      }
    ]
  },
  {
    id: 3,
    title: 'Trabajadores',
    path: '#',
    perfil: [1],
    icon: getIcon('eva:person-done-fill'),
    children: [
      {
        id: 31,
        title: 'Alta Trabajador',
        path: '#',
        perfil: [1],
        icon: getIcon('eva:plus-square-fill'),
        component: TrabajadoresAlta,
        params: {}
      },
      {
        id: 32,
        title: 'List. Trabajadores',
        path: '#',
        perfil: [1],
        icon: getIcon('eva:list-fill'),
        component: Trabajadores,
        params: {}
      }
    ]
  },
  {
    id: 4,
    title: 'Servicios',
    path: '#',
    perfil: [1],
    icon: getIcon('eva:briefcase-fill'),
    children: [
      {
        id: 41,
        title: 'Alta Servicio',
        path: '#',
        perfil: [1],
        icon: getIcon('eva:plus-square-fill'),
        component: ServiciosAlta,
        params: {}
      },
      {
        id: 42,
        title: 'List. Servicios',
        path: '#',
        perfil: [1],
        icon: getIcon('eva:list-fill'),
        component: Servicios,
        params: {}
      }
    ]
  },
  {
    id: 5,
    title: 'Salas',
    path: '#',
    perfil: [1],
    icon: getIcon('eva:home-fill'),
    children: [
      {
        id: 51,
        title: 'Alta Sala',
        path: '#',
        perfil: [1],
        icon: getIcon('eva:plus-circle-fill'),
        component: RoomsAlta,
        params: {}
      },
      {
        id: 52,
        title: 'List. Salas',
        path: '#',
        perfil: [1],
        icon: getIcon('eva:grid-fill'),
        component: Rooms,
        params: {}
      }
    ]
  }
];

const menuFilter = () => {
  const user = workWithLocalStorage('get', 'usuario', null);
  const userPerfil = user ? Number(user.idPerfil || user.perfil || 1) : 1;

  const result = [];
  menuConfig.forEach((item) => {
    if (item.perfil && item.perfil.includes(userPerfil)) {
      const itemCopy = { ...item };
      if (item.children && Array.isArray(item.children)) {
        itemCopy.children = item.children.filter((child) => child.perfil && child.perfil.includes(userPerfil));
      }
      result.push(itemCopy);
    }
  });
  return result;
};

const menu = menuFilter();

export default menu;
